import React from 'react';
import { FilterContent, SearchWrapper } from './filter-management-users.styles';
import { FilterEmployeesListProps } from './types';
import { Search } from '@shared/ui/search/search';
import { Filter } from '@shared/ui/filter/filter';
import { DEFAULT_USERS_LIST_PARAMETERS } from '@entities/user/config/store-constants';
import { Select } from '@shared/ui/select/select';
import { USER_STATUS_OPTIONS } from '@entities/user/config/ui-constants';

export const FilterEmployeesList: React.FC<FilterEmployeesListProps> = ({
    usersListParameters,
    setUsersListParameters,
}) => {
    return (
        <SearchWrapper>
            <Search parameters={usersListParameters} placeholder='Поиск' setParameters={setUsersListParameters} />
            <Filter onResetAllFilters={() => setUsersListParameters(DEFAULT_USERS_LIST_PARAMETERS)}>
                <FilterContent>
                    <Select
                        label='Статус'
                        placeholder='Выберите из списка'
                        values={USER_STATUS_OPTIONS.filter(
                            (option) => String(usersListParameters.active) === option.value
                        )}
                        options={USER_STATUS_OPTIONS}
                        onChange={(value) =>
                            setUsersListParameters((prev) => ({
                                ...prev,
                                active: value[0]?.value ? value[0].value === 'true' : null,
                            }))
                        }
                    />
                </FilterContent>
            </Filter>
        </SearchWrapper>
    );
};
